import { isFixedModel, previewProductName } from '../configurator/productPreview';
import { SHAPE_LABELS } from '../configurator/windowShapes';
import { hasSlidingMesh, isSlidingModel } from '../configurator/slidingOptions';
import { bifoldCount, bifoldSide } from '../configurator/bifoldSettings';

const PATTERNS = { grid: 'Grid', top: 'Top band', bottom: 'Bottom band', border: 'Border', left: 'Left', right: 'Right' };
export const inches = value => `${Number(Number(value).toFixed(2))} in`;
export const shareLink = id => `${window.location.origin}/configure/product?shared=${id}`;

export function designTitle(design, product) {
  const variant = product?.short_label && !isSlidingModel(design.model_id) ? ` · ${product.short_label}` : '';
  return `${previewProductName(design)}${variant}`;
}

export function designRows(design, product, finish) {
  const fixed = isFixedModel(design.model_id), corner = design.layout === 'corner', bars = design.dividers || {};
  const layout = corner ? `90° corner · ${fixed ? 'glass-to-glass' : 'postless'}` : design.sd_pocket || product?.pocket ? 'Straight · pocket' : 'Straight';
  const rows = [['Product', designTitle(design, product)], ['Layout', layout]];
  if (design.model_id === 'ad90-pivot') {
    rows.push(['Opening direction', design.pivot_direction === 'outward' ? 'Outward' : 'Inward']);
    rows.push(['Pivot position', `${design.pivot_offset_pct ?? 84.2}% from the left edge of the leaf · visual concept`]);
    rows.push(['Leaf depth', '90 mm · CAD-derived profile']);
  }
  if (isSlidingModel(design.model_id)) rows.push(['Insect mesh', hasSlidingMesh(design) ? 'Retractable mesh · visual concept' : 'None']);
  if (fixed) rows.push(['Shape', corner ? 'L-shaped · 2 fixed panes' : SHAPE_LABELS[design.window_shape || 'rectangle']]);
  rows.push([corner ? 'Side A width' : 'Width', inches(design.run_a.width_in)]);
  if (design.run_b) rows.push(['Side B width', inches(design.run_b.width_in)]);
  rows.push(['Height', inches(design.height_in)]);
  if (design.swing_leaves) rows.push(['Top', design.swing_top === 'arch' ? 'Round-top arch' : 'Square']);
  if (design.swing_leaves) {
    rows.push(['Threshold', design.swing_threshold === 'high' ? 'High · 57 mm assembled (30 mm rise + 27 mm threshold)' : 'Low · 27 mm high']);
    rows.push(['Moving leaf depth', '70 mm · same leaf profile for single and French doors']);
  }
  if (design.swing_leaves) rows.push(['Leaves', `${design.swing_leaves === 'double' ? 'Double (French)' : 'Single'} · opens ${design.swing_direction}${design.swing_leaves === 'double' ? '' : ` · ${design.swing_hand}-hand hinges`}`]);
  else if (design.bifold_layout) {
    const side = bifoldSide(design.bifold_layout);
    rows.push(['Panels', `${bifoldCount(design.bifold_layout)} bi-fold panels`]);
    rows.push(['Stacking side', side === 'split' ? `${design.bifold_layout.split('+')[0]} left / ${design.bifold_layout.split('+')[1]} right (saved split layout)` : side === 'right' ? 'Right' : 'Left']);
  }
  else if (!fixed) rows.push(['Panels', design.run_b ? `Side A: ${design.run_a.panels} · Side B: ${design.run_b.panels}` : `${design.run_a.panels}`]);
  rows.push(['Finish', finish ? `${finish.label} (${finish.code})` : design.finish]);
  if (bars.pattern === 'sunburst') rows.push(['Grilles', `Sunburst arch · ${bars.rays || 5} rays${bars.horizontal || bars.vertical ? ` · ${bars.horizontal || 0} horizontal × ${bars.vertical || 0} vertical below` : ''} · ${inches(bars.bar_width_in)} bars`]);
  else rows.push(['Grilles', bars.horizontal || bars.vertical ? `${bars.horizontal || 0} horizontal × ${bars.vertical || 0} vertical · ${PATTERNS[bars.pattern] || bars.pattern} · ${inches(bars.bar_width_in)} bars` : 'None']);
  return rows;
}
